// extracted by mini-css-extract-plugin
export default {"labelWithValue":"bZ8ng","smallText":"mbJyl"};